// @flow
import popOverFactory from 'common/components/core/popover/popOverFactory';
import Div from './Div';

const DivWithPopover = popOverFactory({ Component: Div });
export default DivWithPopover;
